import { ref } from 'vue'

const sessionExpiredOpen = ref(false)
const sessionExpiredCanRefresh = ref(false)
let resolveChoice: ((choice: 'exit' | 'stay') => void) | null = null

function showSessionExpired(canRefresh: boolean): Promise<'exit' | 'stay'> {
  if (sessionExpiredOpen.value) {
    return new Promise((res) => {
      if (resolveChoice) resolveChoice('exit')
      resolveChoice = res
    })
  }
  sessionExpiredOpen.value = true
  sessionExpiredCanRefresh.value = canRefresh
  return new Promise<'exit' | 'stay'>((resolve) => {
    resolveChoice = resolve
  })
}

function chooseSessionExpired(choice: 'exit' | 'stay') {
  sessionExpiredOpen.value = false
  if (resolveChoice) {
    resolveChoice(choice)
    resolveChoice = null
  }
}

/**
 * Singleton for use outside Vue components (e.g. api.ts).
 */
export const sessionExpiredState = {
  get open() {
    return sessionExpiredOpen.value
  },
  get canRefresh() {
    return sessionExpiredCanRefresh.value
  },
  show: showSessionExpired,
  choose: chooseSessionExpired
}

/**
 * Composable for session-expired modal in Vue components.
 */
export function useSessionExpired() {
  return {
    sessionExpiredOpen,
    sessionExpiredCanRefresh,
    show: showSessionExpired,
    choose: chooseSessionExpired
  }
}
